import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=bdf10c3c&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf10c3c",
  null
  
)

export default component.exports